import React, { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function CommunityAiCard({ communityId }) {
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    let active = true;
    api.get("/features")
      .then((r) => { if (active) setEnabled(!!r.data?.haeven4_community_ai); })
      .catch(() => { if (active) setEnabled(false); });
    return () => { active = false; };
  }, []);

  if (!enabled) return null;

  const summarize = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/community-ai/${communityId}/summary`);
      setResult(r.data);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not summarize this community yet");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="brutal-card bg-accent p-5" data-testid="community-ai-card">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="text-xs uppercase tracking-[0.18em] font-bold opacity-70 flex items-center gap-2">
            <Sparkles size={14} /> HAEVEN Community AI
          </div>
          <h3 className="text-2xl mt-1">Catch up without endless scrolling</h3>
          <p className="text-sm mt-1 max-w-2xl">
            Summarize recent discussion into themes, useful decisions, open questions, and possible next steps.
          </p>
        </div>
        <button onClick={summarize} disabled={busy}
          className="brutal-btn bg-primary text-primary-foreground px-4 py-2 disabled:opacity-60">
          {busy ? "Summarizing…" : result ? "Refresh summary" : "Summarize discussion"}
        </button>
      </div>

      {result && (
        <div className="mt-4 brutal-card bg-card p-4" aria-live="polite">
          <div className="text-sm whitespace-pre-wrap leading-relaxed">{result.summary}</div>
          <div className="text-xs text-muted-foreground mt-3 border-t border-foreground/20 pt-2">
            {result.disclosure} · Based on {result.source_post_count} recent discussion item{result.source_post_count === 1 ? "" : "s"}.
          </div>
        </div>
      )}
    </section>
  );
}
